import { MasterCrudPage } from '@/components/MasterCrudPage.jsx';
import { formatLKR, rupeesToCents, centsToRupees } from '@/lib/format.js';

export default function PayGradesPage() {
  return (
    <MasterCrudPage
      title="Pay Grades"
      description="Salary band reference data"
      endpoint="/pay-grades"
      queryKey={['payGrades']}
      fields={[
        { name: 'code', label: 'Code', required: true },
        { name: 'name', label: 'Name', required: true },
        { name: 'min_basic', label: 'Min Basic (LKR)', type: 'number', step: '0.01' },
        { name: 'max_basic', label: 'Max Basic (LKR)', type: 'number', step: '0.01' },
      ]}
      hydrate={(r) => ({ ...r, min_basic: centsToRupees(r.min_basic_cents), max_basic: centsToRupees(r.max_basic_cents) })}
      serialize={(v) => ({
        code: v.code, name: v.name,
        min_basic_cents: rupeesToCents(v.min_basic),
        max_basic_cents: rupeesToCents(v.max_basic),
      })}
      columns={[
        { key: 'code', header: 'Code', sortable: true, className: 'font-mono' },
        { key: 'name', header: 'Name', sortable: true },
        { key: 'min_basic_cents', header: 'Min Basic', render: (r) => formatLKR(r.min_basic_cents), className: 'text-right tabular-nums' },
        { key: 'max_basic_cents', header: 'Max Basic', render: (r) => formatLKR(r.max_basic_cents), className: 'text-right tabular-nums' },
      ]}
    />
  );
}
